(function () {
  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector("details-modal.header__search");
    const searchModal = document.querySelector("details-modal.header__search > details");
    const mobileMenuModal = document.querySelector("header-drawer > details");
    const allSubmenu = document.querySelectorAll(".header__submenu");
    const allMegaMenuItemsDesktop = document.querySelectorAll('.list-menu--megamenu');

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty("--ann-height", `${entry.boundingClientRect.height}px`);
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });

    if (annBar) {
      annBarObserver.observe(annBar);
    } else {
      document.documentElement.style.setProperty("--ann-height", `0px`);
    }

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        } else {
          menuLinks.forEach((el) => {
            el.classList.add("list-menu-item--inactive");
            el.classList.remove("list-menu-item--active");
            el.classList.remove("list-menu--megamenu-visible");
          });
          link.classList.remove("list-menu-item--inactive");
          link.classList.add("list-menu-item--active");
        }
      });
    });

    allSubmenu.forEach((submenu) => {
      const links = submenu.querySelectorAll(".header__submenu-item:not(.header__submenu-item--grandchild)");

      links.forEach((link) => {
        const childLinks = link.parentElement.querySelectorAll(".header__submenu-item--grandchild");

        link.addEventListener("mouseenter", (e) => {
          links.forEach((el) => {
            el.classList.add("header__submenu-item--inactive");
          });
          link.classList.remove("header__submenu-item--inactive");
        });

        childLinks.forEach((childLink) => {
          childLink.addEventListener("mouseenter", (e) => {
            childLinks.forEach((el) => {
              el.classList.add("header__submenu-item--inactive");
            });
            childLink.classList.remove("header__submenu-item--inactive");
          });
        });

        link.addEventListener("mouseleave", (e) => {
          childLinks.forEach((el) => {
            el.classList.remove("header__submenu-item--inactive");
          });
        });
      });

      submenu.addEventListener("mouseleave", (e) => {
        links.forEach((el) => {
          el.classList.remove("header__submenu-item--inactive");
        });
      });
    });

    menu?.addEventListener("mouseleave", (e) => {
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu-item--inactive");
        link.classList.remove("list-menu-item--active");
        link.classList.remove("list-menu--megamenu-visible");
      });

      document.querySelectorAll(".header__submenu-item").forEach((link) => {
        link.classList.remove("header__submenu-item--inactive");
      })
    });

    if (header && header.classList.contains("color-background-overlay")) {
      header.addEventListener("mouseenter", () => {
        header.classList.remove("color-background-overlay");
        header.classList.add("color-background-overlay-hidden");
      });

      header.addEventListener("mouseleave", () => {
        if (!searchModal.hasAttribute("open") && !mobileMenuModal.hasAttribute("open")) {
          header.classList.add("color-background-overlay");
          header.classList.remove("color-background-overlay-hidden");
        }
      });
    }

    const calcMegaMenuPosition = (items) => {
      const headerRect = header.getBoundingClientRect()
  
      items.forEach((item) => {
        const megaMenuEl = item.querySelector('.mega-menu')
        if (!megaMenuEl) return
        const itemRect = item.getBoundingClientRect()
        megaMenuEl.style.removeProperty("top");
        if (headerRect.bottom > itemRect.bottom) {
          const diffTop = headerRect.bottom - itemRect.bottom
          megaMenuEl.style.top = `calc(100% - ${diffTop}px)`
        }
      })
    }

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaMenuPosition(allMegaMenuItemsDesktop)
      });
    });

    observer.observe(header);
  };

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    if (!annBar) return;
    let annBarObserver;
    const createAnnBarObserver = () => {
      if (annBarObserver) annBarObserver.disconnect();
      annBarObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) annBarObserver.observe(annBar);
    };
    createAnnBarObserver();
  }

  const initPromoWithSubmenu = (header) => {
    const promoWithSubmenuLinks = header.querySelectorAll('.promo-with-submenu')
    if (!promoWithSubmenuLinks || !promoWithSubmenuLinks.length) return

    promoWithSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll('.promo-with-submenu__link')
      const submenus = link.querySelectorAll('.promo-with-submenu__submenu')

      const onToggle = (event) => {
        const tab = event.target.closest('.promo-with-submenu__link')
        if (!tab) return

        const tabId = tab.dataset.tabId

        tabs.forEach((tab) => {
          tab.classList.remove('active')
        })

        tab.classList.add('active')

        submenus.forEach((submenu) => {
          submenu.classList.remove('active')
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add('active')
          }
        })
      }

      tabs.forEach((tab) => {
        tab.addEventListener('click', onToggle)
        tab.addEventListener('mouseenter', onToggle)
      })

      // Handle nested submenus (child links of child links) - same logic as first level
      submenus.forEach((submenu) => {
        const submenuItems = submenu.querySelectorAll('.promo-with-submenu__submenu-item.has-submenu')
        const nestedSubmenus = submenu.querySelectorAll('.promo-with-submenu__nested-submenu')

        const onNestedToggle = (event) => {
          const item = event.target.closest('.promo-with-submenu__submenu-item.has-submenu')
          if (!item) {
            // If hovering over nested submenu itself, find which one
            const nested = event.target.closest('.promo-with-submenu__nested-submenu')
            if (nested) {
              const nestedId = nested.dataset.nestedId
              if (nestedId) {
                // Hide all nested submenus
                nestedSubmenus.forEach((n) => {
                  n.style.display = 'none'
                  n.style.opacity = '0'
                  n.style.pointerEvents = 'none'
                })
                // Show this nested submenu
                nested.style.display = 'block'
                nested.style.opacity = '1'
                nested.style.pointerEvents = 'all'
              }
            }
            return
          }

          const nestedId = item.dataset.nestedId
          if (!nestedId) return

          // Hide all nested submenus in this submenu
          nestedSubmenus.forEach((nested) => {
            nested.style.display = 'none'
            nested.style.opacity = '0'
            nested.style.pointerEvents = 'none'
          })

          // Show the target nested submenu
          const targetNested = submenu.querySelector(`.promo-with-submenu__nested-submenu[data-nested-id="${nestedId}"]`)
          if (targetNested) {
            targetNested.style.display = 'block'
            targetNested.style.opacity = '1'
            targetNested.style.pointerEvents = 'all'
          }
        }

        // Show nested submenu on hover of item (same as first level - only mouseenter, no mouseleave)
        submenuItems.forEach((item) => {
          item.addEventListener('mouseenter', onNestedToggle)
        })

        // Keep nested submenu visible when hovering over it (same as first level)
        nestedSubmenus.forEach((nested) => {
          nested.addEventListener('mouseenter', onNestedToggle)
        })
      })
    })
  }

  const initHeaderGroup = () => {
    initAnnBar();
    initHeader();
    const header = document.querySelector(".shopify-section-header");
    if (header) {
      initPromoWithSubmenu(header);
    }
  }

  document.addEventListener("shopify:section:load", initHeaderGroup);
  document.addEventListener("shopify:section:unload", initHeaderGroup);
  document.addEventListener("shopify:section:reorder", initHeaderGroup);

  initHeaderGroup();
})();
